import {
  Box,
  Center,
  Button,
  Heading,
  Tooltip,
  VStack,
  Checkbox,
  Container,
  Text,
  Image,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SimpleGrid,
  RadioGroup,
  Stack,
  Radio
} from "@chakra-ui/react";
import { merge, tap } from "rxjs";

import "@fontsource/just-another-hand"
import "@fontsource/sedgwick-ave-display"

import { useEffect, useState } from "react";
import { MintInfo } from "../core/MintInfo";
import Web3Service from "../core/web3.service";
import Logo from "../images/logo.webp";

interface HeroViewProps {
}

const HeroView: React.FC<HeroViewProps> = () => {
  const web3Service = Web3Service.shared();

  const [sliderValue, setSliderValue] = useState(1)
  const [showTooltip, setShowTooltip] = useState(false)
  const [isWhitelisted, setIsWhitelisted] = useState(false)

  const [option, setOption] = useState<string>('1')

  const [account, setAccount] = useState<string | undefined>(undefined);
  const [mintInfo, setMintInfo] = useState<MintInfo | undefined>(undefined);
  const [isUsdcApproved, setUsdcApproved] = useState<boolean>(false);

  useEffect(() => {
    web3Service.getMintInfo();

    const account$ = web3Service.account$.pipe(
      tap((account) => {
        setAccount(account);
      })
    );

    const mintInfo$ = web3Service.mintInfo$.pipe(
      tap((mintInfo) => {
        setMintInfo(mintInfo);
      })
    );

    const isWhitelisted$ = web3Service.isWhitelisted$.pipe(
      tap((isWhitelisted) => {
        setIsWhitelisted(isWhitelisted);
      })
    );

    const subscription = merge(
      mintInfo$,
      account$,
      isWhitelisted$
    ).subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [account]);

  let buttonEnabled: boolean
  let buttonTitle: string
  let startInfo
  let whitelistLabel

  if (isWhitelisted) {
    whitelistLabel = <>
      <Center pt={8}>
        <Heading as="h2" size="md" fontWeight="bold" textShadow={'lg'}>
          You are whitelisted!
        </Heading>
      </Center>
    </>
  }

  let soldOut: boolean | undefined = false
  if (mintInfo) {
    const now = new Date()
    const publicDate = new Date(Number(mintInfo.publictimestamp) * 1000)
    const wlDate = new Date(Number(mintInfo.wltimestamp) * 1000)

    startInfo = <Box fontFamily={"Just Another Hand"} pt={4} fontSize={'xl'}>
      <Text textAlign={'center'} textColor={'rgb(218, 165, 32)'}><b>Public: {publicDate.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })}</b></Text>
      <Text textAlign={'center'} textColor={'rgb(218, 165, 32)'}><b>WL: {wlDate.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })}</b></Text>
    </Box>

    if (mintInfo.paused) {
      buttonTitle = "Paused"
      buttonEnabled = false
    } else if (now < publicDate && (!isWhitelisted || now < wlDate)) {
      buttonTitle = "Coming Soon"
      buttonEnabled = false
      soldOut = false
    } else {
      soldOut = false
      if (Number(mintInfo.maxSupply) > Number(mintInfo.supply)) {
        buttonTitle = sliderValue > 1 ? `Mint ${sliderValue}` : "Mint"
        buttonEnabled = true
      } else {
        soldOut = true
        buttonTitle = "Sold Out"
        buttonEnabled = false
      }
    }
  } else {
    buttonTitle = "Loading"
    buttonEnabled = false
  }

  let amountSlider = <>
    <Center paddingTop={8}>
      <Slider
        id='mint-amount'
        defaultValue={1}
        min={1}
        max={Number(mintInfo?.maxMint ?? 0)}
        colorScheme='orange'
        onChange={(v) => setSliderValue(v)}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <Tooltip
          hasArrow
          bg='orange.500'
          color='white'
          placement='top'
          isOpen={showTooltip}
          label={sliderValue}
        >
          <SliderThumb />
        </Tooltip>
      </Slider>
    </Center>
  </>

  return (
    <>
      <Container centerContent maxWidth={'4xl'} mt={8}>
        <Box
          maxWidth={'4xl'}
          px={8}
          pb={8}
          rounded={"xl"}
          boxShadow={"md"}
          bg={"rgba(23, 23, 23, 0.5)"}
        >
          <Center>
            <Box maxWidth={480}>
              <Box textAlign={"center"} textColor={'rgb(218, 165, 32)'} fontFamily={"Just Another Hand"} fontSize={'3xl'}>
                <VStack>
                  <Image src={Logo} w={'272px'} h={'120px'} objectFit='contain' mt={4} />
                  <Text>Our goal is to create a simple investment project where funds from drops will be locked in few invest options and reinvested every month for bigger return. Half of income from all investments will be distributed for NFT holders. Easy way for passive income.</Text>
                  <Text as='u'>Mint! Hodl! Earn!</Text>
                  <Text>We have already prepared 3 drops with small supply and we plan to realease much more drops. Our community will have a great influence on the development of the project.</Text>
                  <Text>Join us and be a part of Crypto Money Makers!</Text>
                </VStack>
              </Box>
            </Box>
          </Center>

          <SimpleGrid
            my={8}
            columns={{ base: 1, md: 1 }}
            spacing={{ base: 4, md: 6 }}
          >
            {/* <Box
              position={"relative"}
              p={8}
              rounded={"xl"}
              boxShadow={"md"}
              bg={"rgba(23, 23, 23, 0.5)"}
              border={'2px solid rgb(218, 165, 32)'}
            >
              <Heading w={'100%'} textColor={'white'} textAlign={"center"} fontFamily={"Sedgwick Ave Display"} fontSize={'2xl'}>Membership Card</Heading>
              <Text mt={2} fontFamily={"Just Another Hand"} pt={4} fontSize={'xl'} textAlign={'center'} textColor={'rgb(218, 165, 32)'}><b>{new Date(1698771600 * 1000).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })}</b></Text>

              <Center mt={8}>
                <VStack>
                  <Heading fontFamily={"Just Another Hand"} fontSize={'3xl'}>Price: <b>300 CRO</b></Heading>
                  <Heading fontFamily={"Just Another Hand"} fontSize={'3xl'}>WL Price: <b>200 CRO</b></Heading>
                  <Heading fontFamily={"Just Another Hand"} fontSize={'2xl'} pt={4}> {444}/{444} minted</Heading>
                </VStack>
              </Center>

              <Center>
                <Button
                  mt={8}
                  isDisabled={true}
                  color={'rgb(218, 165, 32)'}
                >
                  Sold Out
                </Button>
              </Center>
            </Box> */}

            <Box
              position={"relative"}
              p={8}
              rounded={"xl"}
              boxShadow={"md"}
              bg={"rgba(23, 23, 23, 0.5)"}
              border={'2px solid rgb(218, 165, 32)'}
            >
              <Heading w={'100%'} textColor={'white'} textAlign={"center"} fontFamily={"Sedgwick Ave Display"} fontSize={'2xl'}>Safe Box</Heading>
              {startInfo}

              <Center mt={8}>
                <VStack>
                  <Heading fontFamily={"Just Another Hand"} fontSize={'3xl'}>Price: <b>30 USDC</b></Heading>
                  <Heading fontFamily={"Just Another Hand"} fontSize={'3xl'}>WL Price: <b>25 USDC</b></Heading>
                  <Heading fontFamily={"Just Another Hand"} fontSize={'2xl'} pt={4}> {mintInfo?.supply.toString() ?? '-'}/{mintInfo?.maxSupply.toString() ?? '-'} minted</Heading>
                </VStack>
              </Center>

              {mintInfo?.currencies && soldOut != undefined && !soldOut && <VStack>
                <Text mt={8}><b>Choose payment method:</b></Text>
                <RadioGroup onChange={setOption} value={option}>
                  <Stack>
                    {/* <Radio value='1'>CRO</Radio> */}
                    {mintInfo && mintInfo.currencies.map((currency, i) => (
                      <Radio key={`${i}_${currency.symbol}`} value={`${i + 1}`}>{currency.symbol} ({Number(currency.max)} left)</Radio>
                    ))}
                  </Stack>
                </RadioGroup>
              </VStack>}

              {whitelistLabel}
              {buttonEnabled ? amountSlider : undefined}

              <Center>
                {
                  !isUsdcApproved ?
                    <Button
                      mt={8}
                      onClick={() => web3Service.mint(sliderValue, true)}
                      isDisabled={!buttonEnabled}
                      color={'rgb(218, 165, 32)'}
                    >
                      {'Approve'}
                    </Button>
                    :
                    <Button
                      mt={8}
                      onClick={() => web3Service.mint(sliderValue, true)}
                      isDisabled={!buttonEnabled}
                      color={'rgb(218, 165, 32)'}
                    >
                      {buttonTitle}
                    </Button>
                }
              </Center>
            </Box>
          </SimpleGrid>
        </Box>
      </Container>
    </>
  );
};

export default HeroView;